<template>
  <section>
    <div class="primary-header">
      <h1 data-qa="Content-Device-Title">
        {{ componentTitle }}
        <small>{{ $route.meta.description }}</small>
      </h1>
    </div>
    <device-info-boxes :total="total"></device-info-boxes>
    <el-input
      @keyup.enter.native="deviceSearch(searchQuery)"
      :placeholder="searchBarPlaceholder"
      class="device-search"
      clearable
      type="text"
      v-model.lazy="searchQuery"
      :disabled="isSearchBarDisabled"
    >
      <el-select
        class="device-filter"
        v-model="selectedFilter"
        data-qa="Device-Filter-Options"
        slot="prepend"
        placeholder="Filter"
        @change="onSelectionChanged"
      >
        <el-option
          :key="op.key"
          :label="op.label"
          :value="op.value"
          v-for="op in filterOptions"
        >
        </el-option>
      </el-select>
      <el-button @click="deviceSearch(searchQuery)" icon="el-icon-search" slot="append"></el-button>
    </el-input>
    <el-table
      @expand-change="handleExpand"
      @row-click="toggleRowExpansion"
      @sort-change="handleSortChange"
      :data="deviceList"
      :element-loading-text="$t('deviceTableLoadingText')"
      :expand-row-keys="expanded"
      :row-key="getRowKey"
      class="device-table"
      data-qa="Content-Device-Table"
      element-loading-background="#FFFFFF"
      fit
      max-height="100%"
      ref="deviceListTable"
      row-class-name="pointer"
      show-header
      v-loading="isLoading"
    >
      <el-table-column class="empty" min-width="5" slot="empty">
        {{ $t('deviceTableEmptyMessageTitle') }}
        <i18n path="deviceTableEmptyMessageBody" tag="p">
          <a place="support" href="mailto:support@exosite.com">support@exosite.com</a>
        </i18n>
      </el-table-column>
      <el-table-column type="expand">
        <template slot-scope="props">
          <device-info
            :fields="props.row.fields"
            :guests="props.row.guest_emails"
            :identity="props.row.identity"
            :owner="props.row.owner_email"
          ></device-info>
        </template>
      </el-table-column>
      <el-table-column sortable prop="identity" :label="$t('deviceTableColSNLabel')" min-width="120"></el-table-column>
      <el-table-column sortable prop="model" :label="$t('deviceTableColModelLabel')" min-width="100">
        <template slot-scope="scope">
          <span>{{ getDeviceModel(scope.row.model) }}</span>
        </template>
      </el-table-column>
      <el-table-column sortable prop="connectedTag" :label="$t('deviceTableColConnectivityStatusLabel')" min-width="120">
        <template slot-scope="scope">
          <i v-if="getConnectedStatus(scope.row.connectedTag) !== '--'" :class="getConnectedStatusIcon(scope.row.connectedTag)"></i>
          <span>{{ getConnectedStatus(scope.row.connectedTag) }}</span>
        </template>
      </el-table-column>
      <el-table-column sortable prop="provisioned_time" :label="$t('deviceTableColProvisionedDateLabel')" min-width="120">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="convertSecTime(scope.row.provisioned_time)" placement="top-start">
            <span class="device-provisioned-date">{{ convertSecTime(scope.row.provisioned_time) }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column sortable prop="last_seen" :label="$t('deviceTableColLastSeenLabel')" min-width="120">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="convertUsTime(scope.row.last_seen)" placement="top-start">
            <span class="device-last-seen">{{ convertUsTime(scope.row.last_seen) }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="firmware_version" :label="$t('deviceTableColFirmwareVerLabel')" min-width="130"></el-table-column>
      <el-table-column min-width="40">
        <template slot-scope="scope">
          <el-tooltip :content="$t('deviceTooltipDeleteText')" effect="dark" placement="top-start" v-if="!scope.row.locked">
            <el-button
              :data-qa="'Content-LockDevice-Button-' + scope.row.identity"
              @click.stop="confirmLock(scope.row.identity, scope.row.sn)"
              size="mini"
              type="text"
            >
              <i class="fa fa-trash fa-2 operation-icons"></i>
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <el-row type="flex" justify="center" v-if="showPagination">
      <el-pagination
        :current-page.sync="pagination.currentPage"
        :disabled="isLoading"
        :layout="pagination.layout"
        :page-size="pagination.limit"
        :total="searchedTotal"
        @current-change="getCurrentPageDevice"
        background
      >
      </el-pagination>
    </el-row>
    <device-lock></device-lock>
  </section>
</template>

<script>
  import main from './Device.js'
  export default main
</script>

<style lang="scss" scoped>
  @import './Device.scss'
</style>



// WEBPACK FOOTER //
// Device.vue?53bdb9da